import { ApplicationRouteURL } from './../config';
import { AuthService } from './../models/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wego-notfound',
  template: `
  <section class="content">
  <div class="col-md-12 text-center">
		<div class="panel panel-danger">
      <div class="panel-heading">
      Page not found
      </div>
      <div class="panel-body"><p>
          Page not found!! We are unable to find the page you are looking for. 
          Please navigate to the <a [routerLink]="urlDefaultPage">Home</a> page.
          </p></div>
    </div>
    </div>
  </section>
  `,
  styles: [`.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`]
})
export class NotFoundComponent implements OnInit {
  urlDefaultPage: string;
  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/notfound.component.ts